import React from "react";

export default function Stars({ rating }: { rating: number }) {
  const pct = Math.max(0, Math.min(100, (rating / 5) * 100));
  return (
    <span style={{ position: "relative", display: "inline-block", whiteSpace: "nowrap", lineHeight: 1 }}>
      <span style={{ color: "#d1d5db" }}>★★★★★</span>
      <span
        aria-hidden="true"
        style={{
          position: "absolute", top: 0, left: 0,
          color: "#f59e0b", overflow: "hidden", width: `${pct}%`,
        }}
      >
        ★★★★★
      </span>
    </span>
  );
}
